import React from 'react'
import Banz from '../components/About/Banz'
import Who from '../components/About/Who'
import Pik from '../components/About/Pik'
import Flex from '../components/Home/Flex'
import Form from '../components/Home/Form'

function About() {
  return (
    <div>
    <Banz/>
    <Who/>
    <Pik/>
    <Flex/>
    <Form/>
    </div>
  )
}

export default About
